import dayjs from 'dayjs'

/**
 * 日付フォーマット変換(YYYY/MM/DD)
 * @param {Date} value
 * @returns {String}
 */
function dateFormatter (date) {
  return dayjs(date).format('YYYY/MM/DD')
}

/**
 * 日付フォーマット変換(YYYY/MM/DD)
 * @param {Date} value
 * @returns {String}
 */
function dateInputFormatter (date) {
  return dayjs(date).format('YYYY-MM-DD')
}

/**
 * 日付フォーマット変換(YYYY/MM/DD HH:mm:ss)
 * @param {Date} value
 * @returns {String}
 */
function dateYmdHmsFormatter (date) {
  return dayjs(date).format('YYYY/MM/DD HH:mm:ss')
}

/**
 * 日付フォーマット変換(MM/DD)
 * @param {Date} value
 * @returns {String}
 */
function dateFormatterMmDd (date) {
  return dayjs(date).format('MM/DD')
}

/**
 * 数値フォーマット変換(999999⇒999,999)
 * @param {Num} value
 * @returns {String}
 */
function numericFormatter (num) {
  if (typeof num === 'string') {
    if (num === '') { return '' }
    const number = parseFloat(num.replaceAll(',', ''))
    return number.toLocaleString(undefined, { maximumFractionDigits: 20 })
  }
  return num.toLocaleString(undefined, { maximumFractionDigits: 20 })
}

/**
 * 少数付き数値フォーマット変換(999999⇒999,999.99)
 * @param {Num} value
 * @param {MinorDigit} value
 * @returns {String}
 */
function numericMinorDigitFormatter (num, minorDigit) {
  var number = num
  if (typeof num === 'string') {
    if (num === '') { return '' }
    number = parseFloat(num.replaceAll(',', ''))
  }
  let formated = number.toLocaleString(undefined, { maximumFractionDigits: 20 })

  if (minorDigit !== 0) {
    const dotPosition = formated.lastIndexOf('.')
    if (dotPosition === -1) {
      formated += `.${'0'.repeat(minorDigit)}`
    } else {
      const minorLen = formated.split('.')[1].length
      const padCount = minorDigit - minorLen
      if (padCount > 0) {
        formated += '0'.repeat(padCount)
      } else if (padCount < 0) {
        // 小数桁が多い場合は切り捨てたいなら以下を追加
        formated = formated.split('.')[0] + '.' + formated.split('.')[1].slice(0, minorDigit)
      }
    }
  }
  return formated
}

/**
 * 時刻フォーマット変換(Min⇒HH:MM)
 * @param {Min} value
 * @returns {String}
 */
function minToTimeFormatter (min) {
  return ('0' + Math.floor(min / 60)).slice(-2) + ':' + ('0' + min % 60).slice(-2)
}

/**
 * 時間フォーマット変換(Min⇒HHH:MM)
 * @param {Min} value
 * @returns {String}
 */
function minToIntervalTimeFormatter (min) {
  var hh = String(Math.floor(min / 60))
  hh = hh.length < 3 ? ('0' + hh).slice(-2) : hh
  var mm = ('0' + min % 60).slice(-2)
  return hh + ':' + mm
}

/**
 * 時間フォーマット変換(HH:MM⇒Min)
 * @param {Time} value
 * @returns {String}
 */
function timeToMinFormatter (time) {
  var timeString = String(time)
  if (timeString.indexOf(':') === -1) { return time }
  var data = timeString.split(':')
  return parseInt(data[0], 10) * 60 + parseInt(data[1], 10)
}

/**
 * 接尾辞（単位など）やカンマを含む文字列を浮動小数点数に変換します。
 * * @param {string | number} value - 変換対象の文字列 (例: "1,234.50 kg") または数値。
 * @param {string} [suffix] - 文字列の末尾から除去する接尾辞 (例: " kg", " 円", "%")。省略可能です。
 * @returns {number} 変換後の数値。変換できない場合は0を返します。
 */
function parseNumeric (value, suffix) {
  // 入力が既に数値の場合は、そのままの値を返す
  if (typeof value === 'number' && isFinite(value)) {
    return value
  }
  // 文字列でない、または空文字列の場合は0を返す
  if (typeof value !== 'string' || value.trim() === '') {
    return 0
  }
  let processingString = value.trim()
  // 1. suffixが文字列として指定されている場合、末尾から除去する
  if (typeof suffix === 'string' && suffix.length > 0 && processingString.endsWith(suffix)) {
    // sliceを使って末尾のサフィックス部分を切り落とす
    processingString = processingString.slice(0, -suffix.length).trimEnd()
  }
  // 2. カンマをすべて除去する
  const numericString = processingString.replace(/,/g, '')
  // 3. 文字列を浮動小数点数に変換する
  const result = parseFloat(numericString)
  // 4. 変換結果がNaN（非数値）であれば0を、そうでなければ変換結果を返す
  //    parseFloatは"123foo"を123と解釈するため、多くのケースで意図通りに動作します。
  return isNaN(result) ? 0 : result
}

export default {
  dateFormatter,
  dateInputFormatter,
  dateYmdHmsFormatter,
  dateFormatterMmDd,
  numericFormatter,
  numericMinorDigitFormatter,
  minToTimeFormatter,
  minToIntervalTimeFormatter,
  timeToMinFormatter,
  parseNumeric
}
